function Impressum() {
  return (
    <div className="legal-page">
      <div className="legal-content">
        <h1>Impressum</h1>

        <h2>Angaben gemäß § 5 TMG</h2>
        <p>
          IMA Innovationsmanufaktur Gütersloh GmbH<br />
          Langer Weg 7b<br />
          33332 Gütersloh
        </p>
        <p>
          UID: DE356112656<br />
          Handelsregister: HRB 12904<br />
          Registergericht: Amtsgericht Gütersloh<br />
          Vertreten durch: Jörg Rodehutskors
        </p>

        <h2>Kontakt</h2>
        <p>
          Mobil: 0151 70 65 03 15<br />
          E-Mail: <a href="mailto:info@st-5.eu">info@st-5.eu</a>
        </p>

        <h2>Redaktionell verantwortlich</h2>
        <p>Jörg Rodehutskors</p>

        <h2>EU-Streitschlichtung</h2>
        <p>
          Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:{' '}
          <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer">https://ec.europa.eu/consumers/odr/</a>.
          Unsere E-Mail-Adresse finden Sie oben im Impressum.
        </p>

        <h2>Verbraucherstreitbeilegung/ Universalschlichtungsstelle</h2>
        <p>
          Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
        </p>

        <p>
          Alle auf dieser Website veröffentlichten Inhalte unterliegen dem Copyright der IMA Innovationsmanufaktur Gütersloh GmbH, sofern diese nicht anders gekennzeichnet sind. Jede Speicherung, Vervielfältigung, Verbreitung, Wieder- und Weitergabe der Inhalte ist ohne schriftliche Genehmigung der IMA Innovationsmanufaktur Gütersloh GmbH ausdrücklich untersagt.
        </p>

        <h2>Fotos</h2>
        <p>IMA Innovationsmanufaktur GmbH</p>
      </div>
    </div>
  );
}

export default Impressum;
